import { cva } from 'class-variance-authority';

/**
 * Button styling, kept out of `Button.tsx` so that file exports nothing but
 * components — a module mixing the two silently disables React Fast Refresh
 * for it.
 *
 * Exported because anything that needs to *look* like a button without being
 * one should reuse this rather than approximate it.
 */
export const buttonVariants = cva(
  [
    'inline-flex items-center justify-center gap-2 whitespace-nowrap',
    'rounded-md font-medium select-none',
    'transition-colors duration-(--pl-duration-fast) ease-(--ease-planetra)',
    // Both, deliberately: `disabled` covers the native control, `aria-disabled`
    // covers a link or Slot child that has no disabled attribute to set.
    'disabled:pointer-events-none disabled:opacity-50',
    'aria-disabled:pointer-events-none aria-disabled:opacity-50',
  ],
  {
    variants: {
      variant: {
        primary: 'bg-accent text-fg-on-accent hover:bg-accent-hover active:bg-accent-active',
        secondary:
          'border border-line bg-surface-raised text-fg hover:border-line-strong hover:bg-surface',
        ghost: 'text-fg-muted hover:bg-surface-raised hover:text-fg',
        danger: 'bg-danger text-fg-on-accent hover:opacity-90 active:opacity-80',
      },
      size: {
        sm: 'h-8 px-3 text-sm',
        md: 'h-10 px-4 text-sm',
        lg: 'h-11 px-6 text-base',
        icon: 'size-10 p-0',
      },
      block: {
        true: 'w-full',
        false: '',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md', block: false },
  },
);
